export default __webpack_public_path__ + "static/media/cross.18eb41b8.svg";